import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-instagram',
  templateUrl: './icon-instagram.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconInstagramComponent {}
